<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  // beforeCreate() {
  //   if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
  //     console.log("%c It's a local server! ", 'background: #222; color: #bada55');
  //   } else {
  //     if (location.protocol !== 'https:') {
  //       location.replace(`https:${location.href.substring(location.protocol.length)}`);
  //     }
  //     if (window.location.hostname.indexOf("www") == 0) {
  //       window.location = window.location.href.replace("www.", "");
  //     }
  //   }
  // },
  created() {
  },
  mounted() {
    const meta = document.createElement("meta");
    meta.name = "viewport";
    meta.content = "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no";
    document.getElementsByTagName("head")[0].appendChild(meta);

    document.addEventListener("gesturestart", function (e) {
      e.preventDefault();
    });
  },
  methods: {
  },
}
</script>

<style>
html,
body {
  height: 100%;
  /* background-color: #003399; */
  /* background-color: #11388f; */
  /* background-color: #0f388f; */
  background-color: #0735a1;
  margin: 0;
  padding: 0;
}

/* body {
  min-height: 820px;
} */

body::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #F5F5F5;
}

body::-webkit-scrollbar {
  width: 3px;
  height: 3px;
  background-color: #F5F5F5;
}

body::-webkit-scrollbar-thumb {
  background-color: #000000;
  border: 2px solid #555555;
}

body {
  touch-action: manipulation;
}
</style>

<style>
@import './has-tooltip.css';
@import './column16.css';

/* @import url(//fonts.googleapis.com/css?family=Raleway:300);
#app {
  font-family: "Raleway", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-family: Georgia,Times,Times New Roman,serif;
  font-family: 'Boing', sans-serif;
  font-weight: 300;
} */

#app {
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 300;
}

.w-100 {
  width: 100% !important;
}

.w-90 {
  width: 90% !important;
}

.text-center {
  align-items: center !important;
}

.cursor_pointer {
  cursor: pointer !important;
}

.swal2-container {
  z-index: 1100 !important;
}

.swal2-modal-sm {
  transform: scale(0.5) !important;
}

.swal2-modal-md {
  transform: scale(0.7) !important;
}

.swal2-modal-chat {
  right: -100px;
  bottom: 300px;
  position: fixed;
}

.swal2-modal-message {
  right: -35px;
  bottom: 380px;
  position: fixed;
}

@media screen and (max-width: 576px) {
  .swal2-modal-message {
    right: 0px;
  }
}

.swal-text {
  text-align: center !important;
}

.swal-footer {
  text-align: center !important;
}

.v-toast__text {
  font-size: 12px !important;
}

.float-right {
  float: right !important;
}

.multiselect__tag {
  background: #3273dc !important;
}

.multiselect__tag-icon:after {
  color: #fff !important;
}

.multiselect__content {
  margin: 0 !important;
}

.show-mobile {
  display: none !important;
}

@media screen and (max-width: 576px) {

  /* (max-width: 767px) */
  .hidden-mobile {
    display: none !important;
  }

  .show-mobile {
    display: block !important;
  }
}

.photo-album {
  border-radius: 9px;
  width: 100%;
  height: 175px !important;
  object-fit: cover !important;
}

/* .................................................. */
.btn-group-xs>.btn,
.btn-xs {
  padding: .3rem .2rem;
  font-size: .575rem;
  line-height: .5;
  border-radius: .2rem;
}

/* .................................................. */
.fulljustify {
  text-align: justify;
  overflow: hidden;
}

.fulljustify:after {
  content: "";
  width: 100%;
}

@media screen and (max-width: 767px) {
  .none-fulljustify-mobile {
    text-align: start !important;
  }

  .text-center-mobile {
    text-align: center !important;
  }
}


/* .................................................. */
.cut-text {
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
  white-space: nowrap;
}

/* .................................................. */
.fade-scale {
  transform: scale(0);
  opacity: 0;
  -webkit-transition: all .25s linear;
  -o-transition: all .25s linear;
  transition: all .25s linear;
}

.fade-scale.in {
  opacity: 1;
  transform: scale(1);
}

/* .................................................. */
.vuejs-loadmore {
  height: 10px !important;
}

.incDecInput {
  font-size: 14px;
}

.text-blue {
  color: #3273dc;
}

.btn-mta {
  background: #3273dc !important;
}

.bg-dark-blue {
  /* background-color: #0034a1 !important; */
  background-color: #11388f !important;
}

.btn-dark-blue-border {
  background-color: white;
  /* border: 1px solid #0034a1 !important; */
  border: 1px solid #11388f !important;
  /* color: #0034a1 !important; */
  color: #11388f !important;
  transition: background-color 0.3s, color 0.3s;
}

.btn-dark-blue-border:hover {
  /* background-color: #0034a1 !important; */
  background-color: #11388f !important;
  color: white !important;
}

.btn-gray-blue-border {
  background-color: white;
  border: 1px solid #275ed4 !important;
  /* color: #0034a1 !important; */
  color: #11388f !important;
  transition: background-color 0.3s, color 0.3s;
}

.btn-gray-blue-border:hover {
  background-color: #275ed4 !important;
  color: white !important;
}

.text-dark-blue {
  /* color: #0034a1 !important; */
  color: #11388f !important;
}

.bg-notif-card {
  background-color: #3661cd !important
}

.bg-blocked {
  background-color: #405888 !important
}

.text-light-blue {
  color: #699aff !important
}

.modal {
  z-index: 1070 !important;
}

.modal.show {
  display: block !important;
}

.modal.show .modal-content {
  transform: none;
  /* border: 2px solid #024fa0; */
  /* border-radius: 10px; */
}

.modal-drop-shadow {
  border: 0.1px solid transparent;
  box-shadow: inset 0px 1px 3px rgba(0, 0, 0, 0.1),
    0px 1px 5px rgba(0, 0, 0, 0.15);
}

/* .swal-modal {
  border: 4px solid #024fa0;
  border-radius: 10px;
} */

b,
strong {
  font-weight: bold !important;
}

/* .................................................. */
.scroll-dark::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #F5F5F5;
}

.scroll-dark::-webkit-scrollbar {
  width: 3px;
  height: 3px;
  background-color: #F5F5F5;
}

.scroll-dark::-webkit-scrollbar-thumb {
  background-color: #000000;
  border: 2px solid #555555;
}

.bg-whisper-gray {
  background-color: #F5F7FA !important;
}

.btn-outline-teal {
  color: #1BA098;
  border-color: #1BA098;
}

.btn-outline-teal:hover {
  color: #fff;
  background-color: #1BA098;
}

.text-midnight-blue {
  color: #2C3E50;
}


.text-teal {
  color: #1BA098;
}

.text-coral {
  color: #FF6B6B;
}

.text-slate-gray {
  color: #333;
}

.btn-rounded {
  border-radius: 50px;
}

.lgTitle {
  /* midnight-blue  */
  color: #2C3E50 !important;
}

#Register .card-body p {
  /* charcoal-gray */
  color: #333 !important;
}

#Register .form-label {
  /* pacific-teal */
  color: #1BA098 !important;
}

#Register .form-control {
  /* charcoal-gray */
  color: #333 !important;
}

.v-toast {
  z-index: 9999 !important;
}

/* .................................................. */
.reflect {
  position: relative;
}

.reflect::before {
  position: absolute;
  content: attr(data-reflect);
  top: var(--top, 100%);
  left: var(--left, 0px);
  width: 100%;
  transform: scaleY(-1);
  opacity: 0;
  transition: opacity 0.3s ease-in-out, top 0.3s ease-in-out, left 0.3s ease-in-out;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, transparent 90%);
  -webkit-background-clip: text;
  color: transparent;
}

.reflect:hover::before {
  opacity: 1;
}

.list-hover {
  transition: background-color 0.2s ease, padding 0.2s ease;
}

.list-hover:hover {
  background-color: rgba(0, 0, 0, 0.16);
  padding-left: 1.5px;
}

.list-hover:active {
  padding-left: 0px;
}

.brighter-hover:hover {
  background-color: rgba(255, 255, 255, 1);
  transition: background-color 0.3s ease;
}

.property-expand:hover {
  background-color: rgba(0, 0, 0, 0.01);
  transition: background-color 0.3s ease;
}

.under-line-hover:hover {
  text-decoration: underline;
}

.button-lift {
  --lift: 2px;
  transition: transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out;
}

.button-lift:hover {
  transform: translateY(calc(-1 * var(--lift)));
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
}

.button-lift:active {
  transform: translateY(1px);
  box-shadow: none;
}

.button-expand {
  --expand: 1.01;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.button-expand:hover {
  transform: scale(var(--expand));
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
}

.text-lift {
  --lift: 2px;
  display: inline-block;
  transition: transform 0.1s ease-in-out;
}

.text-lift:hover {
  transform: translateY(calc(-1 * var(--lift)));
}

.text-lift:active {
  transform: translateY(1px);
}

.news-title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  font-size: 11px;
  font-weight: bold;
}

.news-meta {
  font-size: 10px;
}

.news-source {
  cursor: pointer !important;
}

.news-title:hover,
.news-source:hover {
  text-decoration: underline;
}

.text-shadow {
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
}

.text-success-custom {
  color: #5ccb4c;
}

.text-m {
  font-size: 12px;
  line-height: 1.4;
}

.ql-size-small {
  font-size: 0.75em;
}

.ql-size-large {
  font-size: 1.5em;
}

.ql-size-huge {
  font-size: 2.5em;
}
</style>